<template>
  <echeancier-facturation :dcf="commandeAchatBailleur" :showErrorDate="false"/>
</template>

<script>
import echeancierFacturation from '@/components/devisCommandes/editionDevisCommande/echeancierFacturation/echeancierFacturation';

export default {
  components: {
    echeancierFacturation,
  },
  props: {
    commandeAchatBailleur: {
      required: true,
      type: Object,
    },
  },
};
</script>
